import planImage from "../../assets/Accesone.png";
import { Link } from "react-router-dom";

function Plans() {
  return (
    <div className="plans-wrapper-new">
      <img src={planImage} alt="Plans" className="plans-image-new" />

      {/* Button wrapper */}
      <div className="demo-btn-new-wrapper">
        <Link to="/contact" className="demo-btn-new">
          Request For Demo
        </Link>
      </div>
    </div>
  );
}


export default Plans;
